import { defaultDictionaryValueMissing } from '../repository';

export type NewsKey = 'AllNews';

export const getDefaultNewsValue = (key: NewsKey): string => {
	switch (key) {
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
